<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <PageHeader :title="title" :items="items"/>

                <b-card>
                    <div class="row mb-2" v-if="seses">
                        <div class="col-sm-4">
                            <span class="badge badge-success">Ep Data Found: {{ seses.length }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Form No.</th>
                                <th>Name</th>
                                <th>Father Name</th>
                                <th>Mothers Name</th>
                                <th>NID</th>
                                <th>Village</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(ses, index) in seses" :key="index">
                                <td>{{index + 1}}</td>
                                <td>{{ ses.form_no }}</td>
                                <td>
                                    <router-link :to="{ name: 'sesView',params: { ses_id: ses.id }}" tag="a" target="_blank">{{ ses.name }}</router-link>
                                </td>
                                <td>{{ ses.father_husband_name }}</td>
                                <td>{{ ses.mother_name }}</td>
                                <td>{{ ses.nid }}</td>
                                <td>{{ ses.village.village_desc }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="loader" class="loader">Loading...</div>
                        <h5 class="text-center text-secondary" v-if="seses.length === 0">
                          No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Voucher EP",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "Titled EP",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Titled Voucher EP",
                        active: true
                    }
                ],
                seses: {},
                search_data: {
                    form_no: '',
                    name: '',
                    village_id: '',
                    mouza_id: '',
                },
                all_villages: [],
                mouzas: [],
                flag: false,
                loader: false
            };
        },

        mounted() {
            this.getEP();
        },
        methods: {
            getEP() {
                this.flag = true
                this.loader = true

                if(this.$route.params.ep_type == 'title'){
                    let titled_ep_info = JSON.parse(localStorage.getItem('titled_ep_info'))
                    if(titled_ep_info[this.$route.params.index].payment_voucher){
                        //console.log('in')
                        let ses_ids = titled_ep_info[this.$route.params.index].payment_voucher.ses_ids.split(',')
                        http.post("api/titled/voucher/ep", {ses_ids: ses_ids}).then(response => {
                            if (!response.error) {
                                this.flag = true;
                                this.loader = false
                                this.seses = response.data;
                            }
                        });
                    } else{
                        this.loader = false
                        this.seses = []
                    }
                }

                if(this.$route.params.ep_type == 'nontitle'){
                    let non_titled_ep_info = JSON.parse(localStorage.getItem('non_titled_ep_info'))
                    if(non_titled_ep_info[this.$route.params.index].payment_voucher){
                        let ses_ids = non_titled_ep_info[this.$route.params.index].payment_voucher.ses_ids.split(',')
                        http.post("api/non-titled/voucher/ep", {ses_ids: ses_ids}).then(response => {
                            if (!response.error) {
                                this.flag = true;
                                this.loader = false
                                this.seses = response.data;
                            }
                        });
                    }else{
                        this.loader = false
                        this.seses = []
                    }
                    
                }
            }
        },
        computed: {
          userPermission () {
            return this.$store.state.user
          },
          villages() {
            const mouza_id  = this.search_data.mouza_id
            return (mouza_id)
                ? this.all_villages.filter(x => x.mouza_id === mouza_id)
                : null
          },
        },
        created () {
          this.$store.dispatch('getUserPermission')
        },
    };
</script>
<style src="vue-select/dist/vue-select.css"></style>
